import isPropValid from "@emotion/is-prop-valid"
import {
  Container as ContainerFix,
  Row as RowFix,
  Col as ColFix,
} from "styled-bootstrap-grid"
import styled from "styled-components"

// This implements the default behavior from styled-components v5
function shouldForwardProp(propName, target) {
  if (typeof target === "string") {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName)
  }
  // For other elements, forward all props
  return true
}

const Row = styled(RowFix).withConfig({
  shouldForwardProp,
})`
  /* Fix for IE11 */
  width: ${({ theme }) =>
    `calc(100% + ${theme.styledBootstrapGrid.row.padding * 2}px)`};
`
const Container = styled(ContainerFix).withConfig({
  shouldForwardProp,
})``

const Col = styled(ColFix).withConfig({
  shouldForwardProp,
})``

export { Container, Row, Col }
